import React, { useMemo } from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import Image from 'frontastic/lib/image';
import Slider from 'components/commercetools-ui/atoms/slider';
import {
  desktop,
  hugeDesktop,
  largeDesktop,
  mediumDesktop,
  mobile,
  tablet,
} from 'helpers/utils/screensizes';
import { breakpoints } from 'helpers/utils/breakpoints';
import { NationalBook, NationalSemibold, Tiempos } from 'fonts';

const FollowUsCorouselStyle = (props: any) => {
  const { content } = props;
  const [isTabletSize] = useMediaQuery(tablet);
  const slidesElement = useMemo(() => {
    return content.cards?.map((card: any, index: number) => (
      <>
      <a href={card.url || '#'} >
        <div className='hover:bg-[#D9D9D9]'>
        {card.image && (
          <Image
            priority
            loading="eager"
            src={encodeURI(card.image?.url)}
            alt={card.image?.description || ''}
            width={220}
            height={220}
            className=" object-cover w-full h-auto"
          />
        )}
        <p className={`line-clamp-2 text-16 font-semibold capitalize leading-[1.625rem] text-[#2B2C39] md:text-14 lg:text-primary-black  2xl:text-16 ${NationalBook.className}`}>{card.title}</p>
        <p className={`text-14 font-normal leading-6 text-[#000000] md:text-12 2xl:text-14 ${NationalBook.className}`}>{card.description}</p>
      </div>
      </a>
      </> 
    ));
  }, [content.cards]);
  return (
    <div className={`bg-[#EDEDED]`}>
    <div
      className={`py-48 md:py-48 md:pb-100  lg:pl-48 xl:pb-100 xl:pt-60 2xl:pb-154 2xl:pl-80 2xl:pt-80`}
    >
      <div className="flex justify-between items-center">
        <Typography as="h3" className={`pb-32 text-32 font-medium text-[#090909] xl:text-36 2xl:text-[3rem] ${Tiempos.className}`}>
          {content.title}
        </Typography>
        <div className="flex flex flex-row gap-12 self-center 2xl:gap-20 mb-40 mr-20">
          {Array.isArray(content.icons) &&
            content.icons.map((item: any, index: number) => (
              <Link key={index} link={item.url?.href || '#'}>
                <Image
                  src={encodeURI(item.icon?.url || '')}
                  alt={item.icon?.description || 'social-icon'}
                  width={24}
                  height={24}
                />
              </Link>
            ))}
        </div>
      </div>
      <div className="bg-[#EDEDED] px-4 py-6 rounded-md">
        <Slider
          dots={false}
          allowTouchMove
          arrows={isTabletSize}
          innerArrows
          allowArrowsOnTouchDevice
          solidArrows
          nextButtonStyles={{ top: '120%', left: 50 }}
          prevButtonStyles={{ top: '120%', left: 0 }}
          slidesPerView={1.5}
          spaceBetween={16}
          breakpoints={{
            [mobile]: {
              slidesPerView: 2.75,
              spaceBetween: 16,
              ...(breakpoints[mobile] ?? {}),
            },
            [tablet]: {
              slidesPerView: 2.7,
              spaceBetween: 16,
              ...(breakpoints[tablet] ?? {}),
            },
            [mediumDesktop]: {
              slidesPerView: 5.85,
              spaceBetween: 16,
              ...(breakpoints[mediumDesktop] ?? {}),
            },
            [desktop]: {
              slidesPerView: 3.75,
              spaceBetween: 16,
              ...(breakpoints[desktop] ?? {}),
            },
            [largeDesktop]: {
              slidesPerView: 5.5,
              spaceBetween: 16,
              ...(breakpoints[largeDesktop] ?? {}),
            },
            [hugeDesktop]: {
              slidesPerView: 6.5,
              spaceBetween: 16,
              ...(breakpoints[hugeDesktop] ?? {}),
            },
          }}
        >
          {slidesElement}
        </Slider>
      </div>
    </div>
    </div>
  );
};
export default FollowUsCorouselStyle;
